import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { UserMatrixRowModel } from '../../../models/user-matrix-row-model';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
@Component({
    selector: 'app-matrix-row-duplicate',
    templateUrl: './matrix-row-duplicate.component.html',
    styleUrls: ['./matrix-row-duplicate.component.scss'],
    standalone: false
})
export class MatrixRowDuplicateComponent implements OnInit {
    @Input() userMatrixRow: UserMatrixRowModel;
    @Output() refreshMatrixrow = new EventEmitter<boolean>();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Error;
    matrixRowAddFormGroup: UntypedFormGroup;
    isDuplicate: boolean;

    constructor(
        private modalService: NgbModal,
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService
    ) {
        this.isDuplicate = false;
    }

    async ngOnInit(): Promise<void> {
        this.matrixRowAddFormGroup = this.fb.group({
            jointId: ['', Validators.required],
        });
        // * checking access level
        this.isDuplicate = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Create);
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    btnDuplicateMatrixRow() {
        if (this.matrixRowAddFormGroup.valid) {
            this.userMatrixRow.jointID = this.matrixRowAddFormGroup.get('jointId').value;
            this.userMatrixRow.userMatrixRowId = null;
            this.createMatrixRow();
            this.modalService.dismissAll();
        }
    }

    async createMatrixRow() {
        this.ngxUiLoaderService.start();
        let result = await this.mgmtApi.createMatrixRow(this.userMatrixRow).toPromise();
        if (result.success === true) {
            let dialogRef = this.modalService.open(SuccessDialogComponent, {
                size: 'sm',
            });
            dialogRef.componentInstance.message = 'Copy of matrix is created!';
            this.globalEmittersService.refreshMatrix.subscribe((res) => {
                this.ngxUiLoaderService.stop();
                if (res === true) {
                    this.refreshMatrixrow.emit(true);
                }
            });
        } else {
            this.userUtilityService.errorModelPopup(result.message);
        }
    }
}
